module.exports = __webpack_public_path__ + "public/img/card_child.7825209d.png";